import { styled } from "@mui/material/styles";

// Components
import { Card, Typography } from "@mui/material";

const styledName = "WalletItem";

export const StyledItemWrapper = styled(Card, { name: styledName })({
  "&": {
    width: "340px",
    height: "100px",
    borderRadius: "10px",
    border: `solid 2px`,
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "pointer",
    marginBottom: "25px",
    transition: "transform 0.2s linear",
    "&:hover": {
      transform: `translate(6px,0)`,
    },
  },
});

export const StyledItemInfo = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
});

export const StyledItemName = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
    fontWeight: "600",
  },
});

export const StyledItemTotal = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.8rem",
  },
});

export const StyledItemType = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
  },
});

export const StyledItemIcon = styled("img", { name: styledName })({
  "&": {
    height: "50px",
    width: "50px",
  },
});
